// extracted by mini-css-extract-plugin
export default {"cls1":"BankLookupBody-BankName_cls1__Z3ire","cls2":"BankLookupBody-BankName_cls2__YbdXW BankLookupBody-BankName_cls1__Z3ire"};